export default {
  'instagram': () => import('@icons/sns/instagram.svg'),
  'instagram-large': () => import('@icons/sns/instagram-large.svg'),
  'tiktok': () => import('@icons/sns/tiktok.svg'),
  'tiktok-large': () => import('@icons/sns/tiktok-large.svg'),
};
